module.exports = __webpack_public_path__ + "static/img/manual_ja_35.7ba36d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/manual_ja_35.png
// module id = eMRn
// module chunks = 4